import type { AppRouteObject } from "../routes";
import { GroupsRoute } from "./routes/Groups";

const routes: AppRouteObject[] = [GroupsRoute];

export default routes;
